<template>
    <b-modal v-model="show" :title="$t('auto.taxesAdd')" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Солиқлар <span class="red">*</span></label>
                        <select class="form-control" v-model="dictionaryData.data.taxType" :class="{invalid : $v.dictionaryData.data.taxType.$error}">
                            <option value=""></option>
                            <option :value="option.code" v-for="option in taxTypes" :key="option.code">{{option.name}}</option>
                        </select>
                        <div class="red" v-if="$v.dictionaryData.data.taxType.$error">Солиқлар</div>
                    </div>
                    <div class="form-group">
                        <label>Қиймати <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.rate" :precision="2" :class="{invalid : $v.dictionaryData.data.taxType.$error}"></numeric-input>
                    </div>
                    <div class="red" v-if="$v.dictionaryData.data.rate.$error">Қиймати</div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators'
    // import {TAX_TYPES} from '@/shared/constants/auto'

    export default {
        name: "TaxEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                dictionaryData: {
                    id: null,
                    dictionaryType: 'TAX',
                    data: {
                        taxType: null,
                        rate: null
                    }
                },
                taxTypes: [],
            }
        },
        validations: {
            dictionaryData: {
                data: {
                    rate: {
                        required
                    },
                    taxType: {
                        required
                    }
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('taxChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            const vm = this;
            this.$eventBus.$on('showTaxEditModal', (data) => {

                this.$http.get('dictionary/tax-type/list')
                    .then(res => {
                        const response = res.data;
                        vm.taxTypes = response;
                    }, err => {
                        console.log(err);
                    });

                if (data) {
                    this.dictionaryData.id = data.id;
                    this.dictionaryData.data = clone(data.data);
                } else {
                    this.dictionaryData.id = null;
                    this.dictionaryData.data = {
                        taxType: null,
                        rate: null
                    };
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>